<template>
<el-form-item label="日期" :rules="[{
  required: true,
  message: '请选择小时'
}]">
  <div class="date-form-item">
    <el-date-picker
      v-model="date"
      type="date"
      :clearable="false"
      :editable="false"
      :picker-options="datePickerOptions"
      style="width:150px;"
      @change="onDateChange"
    />

    <el-select v-model="model.hour">
      <el-option
        v-for="hour in hours"
        :key="hour"
        :value="hour"
        :label="`${hour.padStart(2, '0')}时`"
      />
    </el-select>
  </div>
</el-form-item>
</template>

<script>
import BaseHySplit from './BaseHySplit'
import MFileDateFormatter from './MFileDateFormatter'

export default {
  name: 'DateSelector',
  extends: BaseHySplit,
  data: () => ({
    hours: Object.freeze([]),
    date: null,
    minTS: null,
    maxTS: null
  }),
  computed: {
    trjtype () {
      return this.model.trjtype
    },
    datePickerOptions () {
      return {
        disabledDate: time => {
          let ts = time.getTime()
          return ts < this.minTS || ts > this.maxTS
        }
      }
    }
  },
  methods: {
    setDate (minMFile, maxMFile) {
      let minDate = MFileDateFormatter.getDateByMFileName(minMFile)
      minDate.setDate(minDate.getDate() - 6)
      this.minTS = minDate.getTime()

      let maxDate = MFileDateFormatter.getDateByMFileName(maxMFile)
      maxDate.setHours(23, 59, 59)
      this.maxTS = maxDate.getTime()
      this.$emit('change', this.date = new Date(maxDate))
    },
    getStep1 () {
      this.changeLoadStatus(true)
      let {model} = this
      this.$api.HYSPLIT.step1(model.trjtype, {
        lon: model.lon,
        lat: model.lat
      }).then(data => {
        model.taskId = data.taskId
        let {mfiles} = data

        if (Array.isArray(mfiles)) {
          mfiles.shift()
          let {length} = mfiles

          if (length > 0) {
            if (!model.mfile) {
              this.setDate(mfiles[length - 1], model.mfile = mfiles[0])
            }

            setTimeout(() => {
              this.getStep2()
            }, 0)
          }
        }
      }).catch(console.error).finally(() => {
        model = null
        this.changeLoadStatus(false)
      })
    },
    getStep2 () {
      this.changeLoadStatus(true)

      let {model} = this
      this.$api.HYSPLIT.step2(model.taskId, model).then(data => {
        let {hours} = data

        if (Array.isArray(hours)) {
          this.hours = Object.freeze(hours)
          let hoursLen = hours.length

          if (hoursLen > 0) {
            let {hour} = this.model

            if (hours.indexOf(hour) === -1) {
              this.model.hour = hours[hoursLen - 1]
            }
          } else {
            this.model.hour = null
          }
        } else {
          this.hours = Object.freeze([])
          this.model.hour = null
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onDateChange (date) {
      let mfile = MFileDateFormatter.getMFileNameByDate(date)
      let {model} = this

      if (mfile !== model.mfile) {
        model.mfile = MFileDateFormatter.getMFileNameByDate(date)
        this.getStep2()
      }

      this.$emit('change', date)
    }
  },
  watch: {
    trjtype: {
      immediate: true,
      handler (trjtype) {
        if (trjtype !== null) {
          this.getStep1()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.date-form-item {
  display: grid;
  grid-template-columns: 150px 80px;
  grid-column-gap: 10px;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/DateSelector.vue